module.exports = __webpack_public_path__ + "ca34fc752115caa19ae433e41aa73a5f.svg";